module.exports = __webpack_public_path__ + "static/media/hologramaContainer.b801efea.png";